import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";

const NebulaUltraPlan = React.lazy(() => import('../NebulaUltraPlan'));
const nebulaUltraPlanRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ULTRA_PLAN_PAGE,
        element: <NebulaUltraPlan />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];
export default nebulaUltraPlanRoutesRegistry;
